export default __webpack_public_path__ + "static/media/logo.89006579.svg";